import styled from "@emotion/styled";

export const TooltipContent = styled.div({
    width: 400,
});

export const Root = styled.div({
    width: "100%",
    display: "inline-block",
    position: "relative",
    verticalAlign: "top",
    transition: "width 0.2s ease-in",
    overflow: "hidden",
});
